exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.cancel-btn[data-v-3cef5658] {\n  width: 188px;\n}\n@media (max-width: 1100px) {\n.subscription-symbol[data-v-3cef5658] {\n    text-align: center;\n    width: 100%;\n    margin-bottom: 10px;\n}\nbutton.subscription-btn[data-v-3cef5658] {\n    font-size: 12px;\n}\n}\n", ""]);

// exports
